export default class BrowserNotificationService {
  private static notificationCount = 0;

  private static updateDocumentTitle() {
    const favicon: any = document.getElementById('favicon') ?? {};
    const appleFavicon: any = document.getElementById('apple-favicon') ?? {};
    const title = 'Khula! Supplier';

    if (this.notificationCount > 0) {
      favicon.href = '/favicon-badge.svg';
      appleFavicon.href = '/favicon-badge.svg';
      document.title = `(${this.notificationCount}) ${title}`;
    } else {
      favicon.href = '/favicon.svg';
      appleFavicon.href = '/favicon.svg';
      document.title = title;
    }
  }

  static setCount(count: number) {
    this.notificationCount = count;
    this.updateDocumentTitle();
  }
}
